import script from "./PCSideNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./PCSideNavbar.vue?vue&type=script&setup=true&lang=js"

import "./PCSideNavbar.vue?vue&type=style&index=0&id=79aacbb3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79aacbb3"]])

export default __exports__